import { antd } from "./antd.util";
import { fontAwesome } from "./fontAwesome.util";
import {
  FileExcelOutlined,
  FileJpgOutlined,
  FilePdfOutlined,
  FileGifOutlined,
  FilePptOutlined,
  FileWordOutlined,
  FileTextOutlined,
  FileOutlined,
  FileImageOutlined
} from "@ant-design/icons";

const IconTypeMap = {
  Antd: {
    label: "Ant Icon",
    type: "Antd",
    prefix: "ant_",
    getComponent: iconName => antd.getIconComponent(iconName)
  },
  FontAwesome: {
    label: "Fontawesome",
    type: "FontAwesome",
    prefix: "fa_",
    getComponent: iconName => fontAwesome.getIconComponent(iconName)
  }
};

const FileIconMap = [
  { extensions: ["jpg", "jpeg"], icon: FileJpgOutlined },
  { extensions: ["gif"], icon: FileGifOutlined },
  { extensions: ["pdf"], icon: FilePdfOutlined },
  { extensions: ["ppt", "pptx"], icon: FilePptOutlined },
  { extensions: ["doc", "docx"], icon: FileWordOutlined },
  { extensions: ["txt"], icon: FileTextOutlined },
  { extensions: ["exe"], icon: FileExcelOutlined },
  { extensions: ["png", "svg", "ai"], icon: FileImageOutlined }
];

/**
 * Icon 資料的陣列
 */
export const IconTypeArray = Object.entries(IconTypeMap).map(([key, value]) => value);

/**
 * Icon 資料的物件
 */
export const IconType = Object.entries(IconTypeMap).reduce((iconType, [key, value]) => {
  iconType[key] = value.type;
  return iconType;
}, {});

export const icon = {
  /**
   * 依據顯示用 icon 類型轉換成資料庫的 icon 名稱
   * @param {string} iconName 顯示用 icon 名稱
   * @param {string} iconType 顯示用 icon 類型
   * @returns
   */
  convertIconNameToPersistenceValue(iconName, iconType) {
    return IconTypeMap[iconType].prefix + iconName;
  },
  /**
   * 依據資料庫的 icon 名稱轉換成顯示用 icon 名稱
   * @param {string} iconName 資料庫 icon 名稱
   * @returns
   */
  convertPersisitenceValueToIconName(iconName) {
    const { prefix } = icon.__getIconMapType(iconName) || {};
    return iconName.replace(prefix, "");
  },
  /**
   * 依據資料庫 Icon 名稱轉換成顯示用 icon 類型
   * @param {string} iconName 資料庫 icon 名稱
   * @returns
   */
  getIconType(iconName) {
    const { type } = icon.__getIconMapType(iconName) || {};
    return type;
  },
  /**
   * 依據資料庫 Icon 名稱轉換成顯示用 icon 元件
   * @param {string} iconName 資料庫 icon 名稱
   * @returns
   */
  getIconComponent(iconName) {
    const { getComponent } = icon.__getIconMapType(iconName) || {};
    if (getComponent) {
      const componentIconName = icon.convertPersisitenceValueToIconName(iconName);
      return getComponent(componentIconName);
    }

    return null;
  },
  /**
   * 依檔案名稱（含副檔名）取得對應的 Icon 元件
   * @param {string} fileName 檔案名稱（需包含副檔名）
   * @returns
   */
  getIconByFileNameExtension(fileName) {
    if (fileName) {
      const extension = fileName.split(".")[1];
      const foundIcon = FileIconMap.find(fileIcon => {
        return fileIcon.extensions.includes(extension);
      });

      if (foundIcon) {
        return foundIcon.icon;
      }
    }

    return FileOutlined;
  },
  /**
   * 依據資料庫 Icon 名稱轉換成 icon 資料
   * @param {string} iconName 資料庫 icon 名稱
   * @returns
   */
  __getIconMapType(iconName) {
    return IconTypeArray.find(value => iconName.startsWith(value.prefix));
  }
};
